const Sorting = {
  CREATED: "created",
  MODIFIED: "modified",
  TITLE: "title",
};

const Ordering = {
  ASCENDING: "ascending",
  DESCENDING: "descending",
};

const CurrentSpaceOption = {
  icon: undefined,
  name: "Current Space",
  spaceKey: "current-space-hardcoded",
  type: "space",
  label: "Current Space",
  value: "current-space-hardcoded",
  homepageId: "undefined",
  coverPictureCallback: async () => {},
};

export async function searchBlogposts({ queryKey, pageParam }) {
  const [
    _key,
    {
      labels = [],
      contributors = [],
      spaces = [],
      limit = 2,
      sorting = Sorting.CREATED,
      ordering = Ordering.DESCENDING,
      currentSpaceKey = undefined,
    },
  ] = queryKey;
  let cql = "type = blogpost";
  if (labels.length > 0) {
    cql = cql + ` AND label in (${labels.map((l) => `"${l}"`).join(",")})`;
  }
  if (contributors.length > 0) {
    cql =
      cql +
      ` AND contributor.accountid in (${contributors
        .map((c) => `"${c}"`)
        .join(",")})`;
  }
  if (spaces.length > 0) {
    const indexOfCurrentSpaceOption = spaces.findIndex(
      (spaceKey) => spaceKey === CurrentSpaceOption.spaceKey
    );
    if (indexOfCurrentSpaceOption >= 0) {
      if (currentSpaceKey) {
        spaces.splice(indexOfCurrentSpaceOption, 1, currentSpaceKey);
      } else {
        spaces.splice(indexOfCurrentSpaceOption, 1);
      }
    }

    cql = cql + ` AND space in (${spaces.map((s) => `"${s}"`).join(",")})`;
  }
  if (sorting === Sorting.CREATED) {
    cql = cql + ` ORDER BY created`;
  }
  if (sorting === Sorting.MODIFIED) {
    cql = cql + ` ORDER BY lastmodified`;
  }
  if (sorting === Sorting.TITLE) {
    cql = cql + ` ORDER BY title`;
  }
  if (ordering === Ordering.ASCENDING) {
    cql = cql + ` asc`;
  }
  if (ordering === Ordering.DESCENDING) {
    cql = cql + ` desc`;
  }
  let url = `/rest/api/search?cql=${cql}&limit=${limit}&expand=content.history,content.space,content.metadata.labels,content.metadata.likes,content.children.comment`;

  if (pageParam) {
    url = `${url}&cursor=${decodeURI(pageParam)}`;
  }
  try {
    return window.AP.request(url);
  } catch (e) {
    console.log("cant fetch blogposts");
    console.log(e);
  }
}

export async function getBlogById(contentId) {
  const url = `/rest/api/search?cql=type=blogpost and id=${contentId}&limit=1&expand=content.history,content.space,content.metadata.labels,content.metadata.likes,content.children.comment`;
  try {
    return window.AP.request(url);
  } catch (e) {
    console.log("cant fetch blogpost", contentId);
    console.log(e);
    return undefined;
  }
}
